import * as React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import GridContainer from '../grid/GridContainer'
import GridItem from '../grid/GridItem'
import styles from 'assets/jss/dorm-app/customSelectStyle.js'

const useStyles = makeStyles(styles)

const documents = {
  'Alle Referatsordnungen': 'https://cloud.schollheim.net/s/YSpfNcJwsfZeCxW'
//   Heimrat: 'https://cloud.schollheim.net/index.php/s/fKNPPeCg3PZe2iS',
//   Finanzenreferat: 'https://cloud.schollheim.net/index.php/s/PiTPBmKAMNPgp8A',
//   Netzwerkreferat: 'https://cloud.schollheim.net/index.php/s/3kA5JSs8ds9pS4E',
//   Aufnahmereferat: 'https://cloud.schollheim.net/index.php/s/paoG37cPimRAEsf',
//   Automatenreferat: 'https://cloud.schollheim.net/index.php/s/P5jH6J2WECdpQML',
//   Computerreferat: 'https://cloud.schollheim.net/index.php/s/Qya5TfFTNQ8ercg',
//   Inforeferat: 'https://cloud.schollheim.net/index.php/s/GdXL2BDa3bXRoja',
//   Innenreferat: 'https://cloud.schollheim.net/index.php/s/egHfzeC2PXJHq3G',
//   Kulturreferat: 'https://cloud.schollheim.net/index.php/s/DRC9wH2STk6DNqP',
//   Multimediareferat: 'https://cloud.schollheim.net/index.php/s/5kFA8PjrJc6fSmf',
//   Revisoren: 'https://cloud.schollheim.net/index.php/s/byzHJZioTGbP9bC',
//   'PR-Referat': 'https://cloud.schollheim.net/index.php/s/2dGN3nxMWsRCz9Y',
//   Schlichtungsreferat: 'https://cloud.schollheim.net/index.php/s/gG9kP4P7oyQQEeS',
//   Sportreferat: 'https://cloud.schollheim.net/index.php/s/YTScfDT4HKSHbGj',
//   Tafelreferat: 'https://cloud.schollheim.net/index.php/s/GwLgXDgNayt2gYk',
//   Waschmaschinenreferat: 'https://cloud.schollheim.net/index.php/s/K7XiKK7F2fCbZo2',
//   Werkreferat: 'https://cloud.schollheim.net/index.php/s/EkR8EnPtfrqHyxe',
//   Zimmerreferat: 'https://cloud.schollheim.net/index.php/s/6YxFT3Lt9MkWyEY',
//   Zeitungreferat: 'https://cloud.schollheim.net/index.php/s/cYqq8tLeRdQ2Fs3',
//   Tutoren: 'https://cloud.schollheim.net/index.php/s/CsSqwHkJ9d4ppXc',
//   Barreferat: 'https://cloud.schollheim.net/index.php/s/B2MarGGDk5Y6HeK',
//   'HSV-Vertretung': 'https://cloud.schollheim.net/index.php/s/d9BFC7bb6gGLsFz',
//   Nachhaltigkeitsreferat: 'https://cloud.schollheim.net/index.php/s/eKDjfty5LtBa7Z9',
}

export default function DepartmentInformation() {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          {
            Object.entries(documents).map(([key, value]) => (
              <GridContainer key={key}>
                <GridItem xs={12} sm={12} md={4}>
                  <a rel="noopener noreferrer" target="_blank" href={value}><h5> {key} </h5></a>
                </GridItem>
              </GridContainer>
            ))
          }
        </GridItem>
      </GridContainer>
    </div>
  )
}
